<template>
  <main class="flex h-screen overflow-hidden">
    <SidebarMenu />
    <section class="flex flex-col w-full h-full pb-1 overflow-auto 3xl:container">
      <AppHeader />
      <div class="relative flex-grow w-full h-full overflow-auto bg-slate-50">
        <slot name="content"></slot>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import AppHeader from '@/components/common/AppHeader.vue';
import SidebarMenu from '@/components/common/menus/SidebarMenu.vue';
</script>
